<template>
  <div>
    <client-form/>
  </div>
</template>

<script>
import ClientForm from '@/components/client-form.vue'

export default {
  name: 'ClientView',
  components: {
    ClientForm
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/children/client.view.vue